import DangerIcon from '../../../assets/icons/danger.svg?react';
import { useDeleteDRResource } from '../../../hooks/queries/drResourceQueries';

const DRDeleteModal = ({onClose, drResource, onDeleteSuccess}) => {
  const {mutate: deleteDRResource, isPending} = useDeleteDRResource();
  
  const handleDelete = () => {
    deleteDRResource(drResource.DrResourceSysId, {
      onSuccess: () => {
        onDeleteSuccess();
        onClose();
      },
      onError: (error) => {
        console.error('DR 자원 삭제 실패:', error);
        // 에러 발생 시 모달은 닫지 않음
      }
    });
  }
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header flex-col gap-10">
          <DangerIcon className='text-error'/>
          <h3>DR자원을 삭제하시겠습니까?</h3>
        </div>
        <div className="modal-content">
          <table className='gray-table'>
            <tr>
              <th>DR자원 이름</th>
              <td>{drResource.ResourceName}</td>
            </tr>
            <tr>
              <th>시도</th>
              <td>{drResource.RegionSido}</td>
            </tr>
            <tr>
              <th>참여 DR제도</th>
              <td>{drResource.DrType}</td>
            </tr>

          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-style-5" onClick={onClose} disabled={isPending}>취소</button>
          <button className="btn py-5 px-10 btn-primary" onClick={handleDelete} disabled={isPending}>
            {isPending ? '삭제 중...' : '삭제하기'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DRDeleteModal